module.exports = __webpack_public_path__ + "static/profile-aa34e5b81cc8688af35f40c7b801d697.jpg";